var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoLicensePlateGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Asset-Artboard-Page",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons/24x24/ico_plane-copy-6-icons/24x24/ico_car",
    fill: "#B2B2B2",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.66673326,10 L2.66673326,12 L3.99999993,12 L3.99999993,10.6666667 L11.9999999,10.6666667 L11.9999999,12 L13.3333999,12 L13.3333999,10 L11.3333333,10 L11.3333333,8.66666667 L13.3333999,8.66666667 L13.3333999,8.21755354 L12.9999999,8 L2.99999993,8 L2.66673326,8.21755354 L2.66673326,8.66666667 L4.6666666,8.66666667 L4.6666666,10 L2.66673326,10 Z M4.13333337,6.66666667 L11.866667,6.66666667 L11.0993158,4.66666667 L4.90081781,4.66666667 L4.13333337,6.66666667 Z M5.33333326,12 L5.33333326,13.3333333 L1.33339993,13.3333333 L1.33339993,7.5065798 L2.79877117,6.523219 L4.08598218,3.33333333 L11.914151,3.33333333 L13.201362,6.523219 L14.6667333,7.5065798 L14.6667333,13.3333333 L10.6666666,13.3333333 L10.6666666,12 L5.33333326,12 Z M5.99999984,10 L5.99999984,8.66666667 L9.99999984,8.66666667 L9.99999984,10 L5.99999984,10 Z",
    id: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoLicensePlateGray);
export default __webpack_public_path__ + "static/media/ico_licensePlate_gray.b1c93d4ceaad0c42f2db9d0a1fd68ce4.svg";
export { ForwardRef as ReactComponent };